
"use strict";



const AjaxInjector = require('./ajaxInjector');




export default (function validateForm ({
    validateEndpoint,
    insertEndpoint,
    ajax,
    messageSelector,
    submitSelector,
    beforeSubmit,
    hideOnSuccess,
    afterValidation,
    formatFields,
    onSuccess
}) {
    const inputSelectors = 'input, textarea, select';

    if ( ajax === undefined ) {
        ajax = true;
    }

    let selectors = [];
    let validateTimeout;


    // Get all selected forms
    const selectedForms = () => 
        selectors
            .map(selector => document.querySelector(selector))
            .filter(form => form !== null);


    // Get all inputs in forms
    const inputFields = () => 
        selectedForms()
            .map(element => element.querySelectorAll(inputSelectors))
            .reduce((fields, input) => [...fields, ...input], []);


    // Get all submit buttons
    const submitButtons = () =>
        selectedForms()
            .map(form => {
                if ( submitSelector &&  form.querySelectorAll(submitSelector) ) {
                    return form.querySelectorAll(submitSelector);
                } 

                return form.querySelectorAll('[type="submit"]');
            })
            .reduce((fields, input) => [...fields, ...input], []);



    const setSubmitted = () => selectedForms()
                                .forEach(form => form.dataset.submitted = true);

    const isSubmitted = () => selectedForms().find(form => form.dataset.submitted) !== undefined;


    // Get all formdata in key/value object
    const formData = () => {
        const formData = inputFields()
            .reduce((values, input) => { 
                if ( input.type === 'checkbox' ) {
                    values[input.name] = input.checked ? 1 : 0;
                } else if ( input.type === 'radio' ) {
                    if ( !values[input.name] ) {
                        values[input.name] = '';
                    }

                    if ( input.checked ) {
                        values[input.name] = input.value;
                    }
                } else {
                    values[input.name] = input.value;
                }

                return values;
            }, {});

        if ( formatFields ) {
            return formatFields(formData);
        }

        return formData;
    };


    // Only return fields with filled value
    const filterEmptyFields =
        (formData, response) =>
            Object.keys(formData)
            .filter(name => {
                if ( isSubmitted() ) {
                    return response && response[name];
                }
                return formData[name] && formData[name] !== '' && response && response[name];
            })
                .map(name => ({
                    name,
                    value: response[name]
                }));


    // Return error fields
    const filterFields =
        (formData, response) =>
            Object.keys(formData)
                .filter(name => response && response[name])
                .map(name => ({
                    name,
                    value: response[name]
                }));


    // Add error messages to data attribute
    const addErrorMessages = errors => 
        inputFields()
            .forEach(elem => {
                const currentError = errors.find(error => error.name === elem.name);
                if ( currentError ) {
                    elem.dataset.error = currentError.value;
                } else {
                    elem.removeAttribute('data-error');
                }
            });


    // Show the error messages from data attribute
    const showErrorMessages = () => {
        inputFields()
            .filter(elem => elem.type !== 'hidden')
            .forEach(input => {
                const parent = (input.type === 'radio') ? input.parentNode.parentNode : input.parentNode;

                if ( parent.offsetParent === null ) {
                    return;
                }

                if ( input.dataset.error ) {
                    if ( !parent.querySelector('.error') ) {
                        const error = document.createElement('small');
                        error.classList.add('error');
                        parent.append(error);
                    }

                    parent.querySelector('.error').innerHTML = input.dataset.error;
                } else {
                    if ( parent.querySelector('.error') ) {
                        const errorMsg = parent.querySelector(':scope > .error');

                        if ( errorMsg ) {
                            errorMsg.remove();
                        }
                    }
                }
            });
    };


    // Validate fields by AJAX
    const validation = data => {
        if (!validateEndpoint) return;

        return AjaxInjector.request(
                validateEndpoint,
                'POST',
                data
            );
    };


    // Validate and show errors
    const validateFields = () => {
        const data = formData();

        validation(data)
            .then( errors => {
                const filteredErrors = filterEmptyFields(data, errors);
                addErrorMessages(filteredErrors);
                showErrorMessages(filteredErrors);
                if ( afterValidation ) {
                    afterValidation(data, errors);
                }
            });
    };


    // Show success or error message
    const showMessage = (msg, className = null) => {
        if ( !messageSelector ) {
            messageSelector = '.form_output';
        }

        selectedForms()
            .forEach(elem => elem.dataset.success = true);

        if ( document.querySelector(messageSelector) ) {
            document.querySelectorAll(messageSelector)
                .forEach(elem => {
                    elem.innerHTML = msg;
                    elem.style.display = 'block';

                    elem.classList.remove('error');
                    if ( className ) {
                        elem.classList.add(className);
                    }
                });
        }
    };


    const hideFormElements = () => {
        selectedForms()
            .forEach(form => form.querySelectorAll(':not(.message)')
                .forEach(elem => elem.style.display = 'none'));
    };


    const insertForm = () => {
        if (!insertEndpoint) return;

        if (beforeSubmit) beforeSubmit();

        if ( ajax ) {
            AjaxInjector.request(
                insertEndpoint,
                'POST',
                formData()
            )
            .then(response => {
                if ( hideOnSuccess ) {
                    hideFormElements();
                }
                showMessage(response.message);

                if ( onSuccess ) {
                    onSuccess(response);
                }
            })
            .catch(response => showMessage(response.message, 'error'));
        } else {
            const submitForm = document.createElement('form');
            submitForm.method = 'post';
            submitForm.action = insertEndpoint;

            const data = formData();

            if ( window.oData.csrf_baptist ) {
                data.csrf_baptist = window.oData.csrf_baptist;
            }

            for ( let name in data ) {
                const input = document.createElement('input');
                input.name = name;
                input.value = data[name];

                submitForm.appendChild(input);
            }

            document.body.appendChild(submitForm);
            submitForm.submit();
        }
    };


    // Validate fields with delay
    function validate (delay = 0) {
        window.clearTimeout(validateTimeout);

        validateTimeout = window.setTimeout(validateFields, delay);
    }


    // Setup forms and events
    return function setup () {
        selectors = [...arguments];

        if ( inputFields().length < 1 ) return;

        inputFields().forEach(input => {
            input.addEventListener('change', () => validate(0));
        });

        submitButtons()
            .forEach(form => form.addEventListener('click', evt => {
                evt.preventDefault();

                const data = formData();

                setSubmitted();

                validation(data)
                    .then( errors => {
                        const filteredErrors = filterFields(data, errors);
                        addErrorMessages(filteredErrors);
                        showErrorMessages(filteredErrors);

                        if ( errors === true ) {
                            insertForm();
                        } else {
                            const firstErrorInput = inputFields().find(input => input.dataset.error);
                            if ( firstErrorInput !== undefined ) {
                                const header = document.querySelector('.main-header');
                                const headerHeight = header.getBoundingClientRect().height;
                                
                                const parent = (firstErrorInput.type === 'radio')
                                    ? firstErrorInput.parentNode.parentNode.parentNode
                                    : firstErrorInput.parentNode;
                                const parentTop = parent.getBoundingClientRect().top;

                                window.scrollTo({
                                    top: window.scrollY + parentTop - headerHeight,
                                    behavior: 'smooth',
                                });
                            }
                        }
                    });
            }));


        validate(0);
    };
});
